import * as React from "react";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";

interface IDeclarationsProps extends IProcessComponentProps {}

interface IDeclarationsState {
    checkedDeclarations: number[];
}

export class Declarations extends ProcessComponent<IDeclarationsProps, IDeclarationsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            checkedDeclarations: [],
        };
    }

    isValid() {
        if (this.state.checkedDeclarations.length < 2) {
            this.props.showErrorMsgPopUp(["You must accept all items to continue"], true);
        }

        return super.isValid() && this.state.checkedDeclarations.length == 2;
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;

        return (
            <>
                <h2>Declarations</h2>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Take pension benefits from crystallised account",
                            value: this.state.checkedDeclarations.includes(1),
                            disabled: this.props.isReview,
                            onChange: (v) => {
                                const checked = this.state.checkedDeclarations;
                                if (v) {
                                    this.setState({ checkedDeclarations: checked.concat(1) });
                                } else {
                                    this.setState({ checkedDeclarations: checked.filter((ele) => ele != 1) });
                                }
                            },
                        },
                    ]}
                />
                <p>
                    I can confirm that I have provided my client with an illustration in relation to this withdrawal,
                    inline with my regulatory responsibilities as financial adviser, as detailed in FCA Sourcebook
                    COBS14.
                </p>
                <p>
                    I understand that the taxable part of any payment made will be subject to income tax deducted by
                    Standard Life Assurance Limited (SLAL) and paid to HM Revenue &amp; Customs. Standard Life Assurance
                    Limited (SLAL) will submit my personal and income details to HM Revenue &amp; Customs.
                </p>
                <p>
                    I declare that any full payment of the value of benefits under this SIPP shall constitute a full and
                    final discharge of entitlement to receive benefit from this SIPP.
                </p>
                <p>
                    I have read and understood the content of Standard Life Assurance Limited (SLAL) leaflet
                    'Comprehensive guide to tax and income withdrawals', and the accompanying documents related to
                    taking income from my account.
                </p>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Evidence of age",
                            value: this.state.checkedDeclarations.includes(2),
                            disabled: this.props.isReview,
                            onChange: (v) => {
                                const checked = this.state.checkedDeclarations;
                                if (v) {
                                    this.setState({ checkedDeclarations: checked.concat(2) });
                                } else {
                                    this.setState({ checkedDeclarations: checked.filter((ele) => ele != 2) });
                                }
                            },
                        },
                    ]}
                />
                <p>I confirm that I have seen appropriate evidence of age.</p>
                <p>This can be either:</p>
                <p>A valid driving license or passport, or</p>
                <p>A birth certificate</p>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Confirm all",
                            disabled: this.props.isReview,
                            value: this.state.checkedDeclarations.length == 2,
                            onChange: (v) => {
                                if (v) {
                                    this.setState({ checkedDeclarations: [1, 2] });
                                } else {
                                    this.setState({ checkedDeclarations: [] });
                                }
                            },
                        },
                    ]}
                />
            </>
        );
    }
}
